<template>
  <div>
    <div class="row pt-2">
      <div class="col-3">
        <div @click="showWarning" class="back-btn">
          <img src="@/assets/img/arrow_left.svg" style="display:inline-block;" alt="" />
          Back
        </div>
      </div>
      <div class="col-9">
        <div class="d-flex flex-row align-items-center selected-currency">
          <img
            :src="anyWalletCoin && anyWalletCoin.logo ? anyWalletCoin.logo : ''"
            class="currency-icon"
            :alt="anyWalletCoin.currency"
          />
          <small class="ml-2 mt-1">{{ anyWalletCoin.name }}</small>
          <div
            v-b-tooltip.hover.top="{ customClass: 'my-tooltip-class' }"
            :title="$t('payment.faster-tooltip')"
            v-if="anyWalletCoin.fasterConfirmation"
            class="lightning-icon">
            <img src="@/assets/img/lightning.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-2" v-if="!isPreview">
      <CryptoWalletsQR
        :qrData="qrData"
        :payableData="payableData"
        :currencies="currencies"
        :anyWalletCoin="anyWalletCoin"
        :isCodeExpired="isCodeExpired"
        :anyWalletError="anyWalletError"
        :convertedCart="convertedCart"
        :displayCurrency="displayCurrency"
        :isPreview="isPreview"
        :isContinuedTransaction="isContinuedTransaction"
      />
    </div>
    <div class="tab-data__wrapper">
      <div class="d-flex flex-nowrap align-content-center align-items-center">
        <div class="p-2  flex-grow-1">

          <div class="d-flex my-2" v-for="(step, i) in blockchainSteps" :key="i">
            <img :src="step.icon" class="mr-2" style="width: 20px;height: 20px;" />
            <span style="font-size: 13px;font-weight: 300">{{step.label}}</span>
          </div>

        </div>
        <!-- <div
          v-if="
            anyWalletCoin.currency
              && metaMaskCoins.indexOf(anyWalletCoin.currency) !== -1
          "
          class="metaMask p-2"
        >
          <div class="metaMask-pay mb-2">
            {{ $t("unauth-payment.pay-using") }}
          </div>
          <div>
    
          </div>
        </div> -->
      </div>
    </div>
    <PopupModal
      :title="$t('warning-modal.title')"
      id="1"
      :showModal="warningModal"
      :description="warningMsg"
      :cancel="$t('warning-modal.cancel')"
      :extraWarning="$t('warning-modal.extra-warning')"
      :dismiss="$t('warning-modal.dismiss')"
      @cancelClicked="backToPreviousStep"
      @dismissClicked="warningModal = false"
    />
  </div>
</template>
<script>
/* eslint-disable */

import PopupModal from '@/components/PopupModal.vue';
import CryptoWalletsQR from "@/components/CryptoWalletsQR.vue";
import { META_MASK_COINS, USER_TRACK_EVENTS } from '@/store/modules/user/consts';
import { mapGetters } from 'vuex';

export default {
  name: "SecondStep",
  data() {
    return {
      selectedCurrency: "",
      warningModal: false,
      metaMaskCoins: META_MASK_COINS,
    };
  },
  components: {
    CryptoWalletsQR,
    PopupModal
  },
  props: [
    "anyWalletCoin",
    "anyWalletError",
    "qrData",
    "payableData",
    "currencies",
    "convertedCart",
    "displayCurrency",
    "isPreview",
    "isCodeExpired",
    "isContinuedTransaction"
  ],
  computed: {
    ...mapGetters({
      paymentCompleted: 'auth/paymentCompleted',
    }),
    warningMsg() {
      let msg = this.$t('warning-modal.description')
      let walletName = this.anyWalletCoin && this.anyWalletCoin.name ? this.anyWalletCoin.name : 'crypto';
      msg = msg.replace('[crypto]', ` ${walletName}`);

      return msg;
    },
    blockchainSteps() {
      let stepOneIcon = this.qrData.id ? require('@/assets/img/done.svg') : require('@/assets/img/spinner.gif')
      let stepTwoIcon = require('@/assets/img/circle.png');
      let stepThreeIcon = require('@/assets/img/circle.png');

      if(this.paymentCompleted) {
        stepTwoIcon = require('@/assets/img/done.svg');
        stepThreeIcon = require('@/assets/img/spinner.gif');

        setTimeout(() => {
          stepThreeIcon = require('@/assets/img/done.svg');
        }, 200);
      } else if(this.qrData.id) {
        stepTwoIcon = require('@/assets/img/spinner.gif');
      }

      let steps = [
        {
          icon: stepOneIcon,
          label: "Generating QR Code"
        },
        {
          icon: stepTwoIcon,
          label: "Scanning Blockchain"
        },
        {
          icon: stepThreeIcon,
          label: "Detecting Transaction"
        }
      ]

      return steps;
    }
  },
  methods: {
    showWarning() {
      this.warningModal = true;
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: 'Qr payments',
          activity: `clicked on back button, change currency confirmation required`,
        },
      });
    },
    backToPreviousStep() {
      this.$emit(`backToPreviousStep`);
    },
  }
};
</script>
<style lang="scss" scoped>
.footer-btn {
  padding: 0px 10px;
  cursor: pointer;
  border-radius: 5px;
  color: #5559fe;
  margin: 0px 5px;
  border: 1px solid #5559fe;
}

.footer-btn:nth-child(2) {
  background: #5559fe;
  color: white;
}

.footer-btn:nth-child(1) {
  background: white;
  color: black;
}

.back-btn {
  cursor: pointer;
  margin-top:5px;
}

.selected-currency {
  float:right;
}
.chainNetwork{
  text-transform: capitalize !important;
}
</style>
